export default "__VITE_ASSET__DlYGY7g5__"